import { Spinner } from "react-bootstrap";
import "./faultTypeInfoBoxes.scss";

const FaultTypeInfoBoxes = ({
  count,
  isloading = false,
  name,
  type = "",
  onClick,
}: any) => {
  // 1. Evaluate conditions once
  const isTotal = type === "total";
  const hasCount = count !== 0;

  // 2. Set dynamic properties based on the type
  const containerClass = isTotal ? "totalFaults" : "faultTypes";
  const spinnerVariant = isTotal ? "danger" : "dark";
  const headerStyle = isTotal ? undefined : { fontSize: "32px" };

  return (
    <div className="">
      <div className={containerClass}>
        {isloading ? (
          <Spinner animation="border" variant={spinnerVariant} />
        ) : (
          <button
            type="button"
            className={hasCount ? "cursor-pointer" : ""}
            onClick={hasCount ? onClick : undefined}
            disabled={!hasCount}
            style={{
              background: "none",
              border: "none",
              padding: 0,
            }}
          >
            <header style={headerStyle}>{count}</header>
          </button>
        )}
        <main>{name}</main>
      </div>
    </div>
  );
};

export default FaultTypeInfoBoxes;
